import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    __loadElfsight?: () => void;
  }
}

/**
 * Renders the Elfsight Google Reviews widget container and only triggers
 * loading of the heavy platform.js when the container enters the viewport.
 * This keeps platform.js off the critical path and dramatically lowers TBT
 * on pages that include the widget.
 */
const ElfsightReviews = ({ appId = 'c1c0d2a7-6386-497f-a590-2ca3be0c8a78' }: { appId?: string }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const trigger = () => {
      if (typeof window !== 'undefined' && typeof window.__loadElfsight === 'function') {
        window.__loadElfsight();
      }
    };

    if (typeof IntersectionObserver === 'undefined') {
      // Fallback: load on mount if observer is unavailable.
      trigger();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          trigger();
          io.disconnect();
        }
      },
      { rootMargin: '600px 0px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`elfsight-app-${appId}`} data-elfsight-app-lazy />
  );
};

export default ElfsightReviews;
